module.exports = __webpack_public_path__ + "img/assist.4814bd28.svg";